import React from 'react'
import about1 from '../assets/images/about/vid.jpg'
// import about2 from '../assets/images/about/2.jpg'
// import { Link } from 'react-router-dom'
import VideoOne from './video-one'

export default function About() {
    return (
        <>
            <div className="row align-items-center">
                <div className="col-lg-5 col-md-6 mb-5 mb-md-0 pb-5 pb-md-4">
                    <div className="position-relative">
                        <div className="">
                            <img src={about1} className="img-fluid rounded border border-4 shadow" alt="" />
                        </div>
                        <VideoOne />
                    </div>
                </div>

                <div className="col-lg-7 col-md-6 mt-4 mt-md-0 pt-4 pt-md-0">
                    <div className="section-title ms-lg-5">
                        <h6 className="text-primary small text-uppercase">Quiénes somos</h6>
                        <h4 className="title my-3">
                            Hospital Aranda de la Parra: 85 años de Experiencia, Innovación y Atención Integral en Salud
                        </h4>
                        <p className="para-desc text-muted">
                            En Hospital Aranda de la Parra, combinamos calidez humana con atención médica de primer nivel, ofreciendo un servicio cercano y oportuno. Con más de 85 años de experiencia en salud, nos hemos consolidado como un referente en diagnóstico, tratamientos especializados y tecnología de vanguardia en México.
                        </p>
                        <p className="para-desc text-muted">
                            Nuestro equipo multidisciplinario es el pilar de nuestra excelencia en servicio: médicos, enfermeras, paramédicos, personal de limpieza, cocina, administrativos y más, quienes, con su compromiso diario, hacen posible una atención médica integral y de calidad. La tecnología médica avanzada es nuestra aliada, pero el verdadero valor de nuestro hospital radica en las personas que trabajan día a día por tu bienestar.
                        </p>
                        <p className="para-desc text-muted">
                            Brindamos una amplia gama de servicios médicos especializados, desde cirugías, ginecología, pediatría, cardiología y neurología hasta un enfoque de vanguardia en oncología, proporcionando tratamientos innovadores y un acompañamiento humano en cada etapa.
                        </p>
                        <p className="para-desc text-muted">
                            Hoy, seguimos evolucionando para ser el hospital privado de referencia en la región, combinando experiencia, vanguardia y atención integral en salud para brindarte bienestar y tranquilidad. Juntos Cuidamos de Ti.
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}
